import { t } from "@/i18n-js/instance";
import { ConfirmationCardLayout } from "./ConfirmationCardLayout";

export interface MemberConfirmationCardProps {
  email?: string;
  name?: string;
}

export const MemberConfirmationCard = ({
  name,
  email,
}: MemberConfirmationCardProps) => (
  <ConfirmationCardLayout
    title={t("help_widget.copilot.confirmation_card.member_title")}
    attributes={[
      {
        label: t("help_widget.copilot.confirmation_card.name"),
        value: name,
      },
      {
        label: t("help_widget.copilot.confirmation_card.email"),
        value: email,
      },
    ]}
  />
);
